import Vue from 'vue';
import registryContexts from './registry-contexts';
import { registerStoreModule } from 'framework/vuex/store';

const moduleNameRegex = /\/([^/]+)\/index\.(js|vue)$/;

/**
 * Register a sinlge module
 * @param {Object} moduleObject
 * @param {string} name
 * @param {string} type
 * @param {string} namespace
 */
export function register(moduleObject, name, type, namespace) {
    switch (type) {
        case 'directive':
            Vue.directive(name, moduleObject);
            break;
        case 'filter':
            Vue.filter(name, moduleObject);
            break;
        case 'store':
            registerStoreModule(name, moduleObject);
            break;
        case 'component':
        default:
            Vue.component(`${ namespace }-${ name }`, moduleObject);
            break;
    }
}

/**
 * Prepare the module to be registered
 * @param {Object} config
 * @param {string} moduleString
 */
function prepare(config, moduleString) {
    const moduleObject = config.context(moduleString).default || config.context(moduleString);
    const name = moduleString.match(config.moduleNameRegex || moduleNameRegex);

    register(
        moduleObject,
        name[1],
        config.type,
        config.namespace
    );
}

/**
 * Register all modules
 * @return {Promise} resolve when all contexts have been loaded
 */
export function init() {
    return registryContexts.then((contexts) => {
        contexts.forEach((config) => {
            config.context
                .keys()
                .forEach(prepare.bind(null, config));
        });
    });
}

export default init;



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/framework/base/registry.js